import { render, staticRenderFns } from "./HuygensPrincipleProViz.vue?vue&type=template&id=36539a4e&scoped=true"
import script from "./HuygensPrincipleProViz.vue?vue&type=script&lang=js"
export * from "./HuygensPrincipleProViz.vue?vue&type=script&lang=js"
import style0 from "./HuygensPrincipleProViz.vue?vue&type=style&index=0&id=36539a4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36539a4e",
  null
  
)

export default component.exports